// extracted by mini-css-extract-plugin
export default {"giftOrPromoRowWrapper":"JA-z","giftOrPromoSelector":"KA-z","disabled":"LA-z","subTitle":"MA-z","selectShipAddressMessage":"NA-z","changePayment":"OA-z"};